import React from 'react';
import Head from 'next/head';

type Props = {
  title?: string;
  description?: string;
  imageUrl?: string;
  children?: React.ReactNode;
};

const DEFAULT_TITLE = 'TopHouse';
const DEFAULT_DESCRIPTION = 'TopHouse Real Estate App';

export default function CustomHead({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  imageUrl,
  children,
}: Props) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {children}
    </Head>
  );
}
